import React, { MouseEvent } from 'react';

import { fc } from 'i18n';
import { Option } from './option';
import { ISelectOption } from 'types/select';

import styles from './styles.module.css';

interface IListProps<T> {
  selectedId?: T | null;
  options: ISelectOption<T>[] | null;
  selectOption: (option: ISelectOption<T>) => (event: MouseEvent<HTMLDivElement>) => void;
}

export const List = <T,>({ selectedId, options, selectOption }: IListProps<T>) => (
  <>
    {options?.length ? (
      <div className={styles.list}>
        {options.map((option, index) => (
          <Option key={index} isSelected={selectedId === option.value} option={option} selectOption={selectOption} />
        ))}
      </div>
    ) : (
      <div className={`${styles.list} ${styles.noContent}`}>{fc('no options found')}</div>
    )}
  </>
);
